// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eM-z","twoColumnImage":"fM-z"};